import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as API from 'app/public_api';
import * as T from 'utils/types';

const rSDGStat = createAsyncThunk(
    'rsrFilter/statsInfoSDG',
    async (data:{
        keywordType: T.keywordType,
        searchInput: T.searchInput,
        acceptingGraduateStudentChecked: boolean,
        C3IChecked: boolean,
        facultyID: number,
        departmentID: number
    }, thunkAPI)=>{
        const {
            searchInput, keywordType, acceptingGraduateStudentChecked, C3IChecked,
            departmentID,facultyID,
        } = data;
        return await API.getStat_SDG({
            searchInput,
            keywordType,
            acceptingGraduateStudentChecked,
            C3IChecked,
            deptID: departmentID,
            fcltID: facultyID,
        });
    }
)

const rFcltDeptStat = createAsyncThunk(
    'rsrFilter/rFcltDeptStat', 
    async (data:{
        keywordType: T.keywordType,
        searchInput: T.searchInput,
        acceptingGraduateStudentChecked: boolean,
        C3IChecked: boolean,
        SDGs: number[]
    }, thunkAPI)=>{
        const {
            searchInput, keywordType, acceptingGraduateStudentChecked, C3IChecked,
            SDGs
        } = data;
        return await API.rFcltDeptStat_Rsr(
            searchInput, keywordType, acceptingGraduateStudentChecked, C3IChecked,
            SDGs
        );
    }
)

export const rsrFilterThunks = {rFcltDeptStat, rSDGStat};




export const initialState: T.RsrFilterState = {
    fcltDeptStat: {"total":0, "fclts":[], "depts":[]},
    status: "idle",
    errorMsg: null,
    currentRequestId: null,
    SDG: {
        statInfo: {
            total: 0, 
            statVec: new Array(17).fill(0)
        }, 
        status: 'idle',
        currentRequestId: null,
    },
}

// RsrFilterS: RsrFilterSlice
const RsrFilterS =  createSlice({
    name: 'rsrFilter',
    initialState,
    reducers: {},
    extraReducers: builder=>{

        // Fclt Dept thunk
        builder.addCase(rFcltDeptStat.pending, (state, action) => {
            state.status = 'loading';
            state.currentRequestId = action.meta.requestId;
        });
        builder.addCase(rFcltDeptStat.fulfilled, (state, action) => {

            // below line makes sure the response comes from the most recent request
            if(action.meta.requestId===state.currentRequestId){
                state.status = 'succeeded';

                state.fcltDeptStat = action.payload;
            }
        });
        builder.addCase(rFcltDeptStat.rejected, (state, action) => {
            // below line makes sure the response comes from the most recent request
            if(action.meta.requestId===state.currentRequestId){
                state.status = 'failed';
                state.errorMsg = action.error.message;

                state.fcltDeptStat = initialState.fcltDeptStat;
            }
        });

        // SDG thunk
        builder.addCase(rSDGStat.pending, (state, action) => {
            state.SDG.status = 'loading';
            state.SDG.currentRequestId = action.meta.requestId;
        });
        builder.addCase(rSDGStat.fulfilled, (state, action) => {
            // below line makes sure the response comes from the most recent request
            if(action.meta.requestId===state.SDG.currentRequestId){
                state.SDG.status = 'succeeded';

                state.SDG.statInfo = action.payload;
            }
        });
        builder.addCase(rSDGStat.rejected, (state, action) => {
            // below line makes sure the response comes from the most recent request
            if(action.meta.requestId===state.SDG.currentRequestId){
                state.SDG.status = 'failed';
                state.SDG.errorMsg = action.error.message;

                state.SDG.statInfo = initialState.SDG.statInfo;
            }
        });
    }
});

export default RsrFilterS;